// Mock data for The Jackson House RGV clone
// NOTE: All data below is MOCKED for the frontend-only teaser.

// ---- Property images (self-hosted real photos of The Jackson House) ----
export const IMG = {
  hero: "/house/pool-night.jpg",
  cardAccommodation: "/house/pool-daytime.jpg",
  cardIndoor: "/house/poker-table.jpg",
  cardRGV: "/house/mini-golf.jpg",
  workspace: "/house/workspace.jpg",
  livingRoom: "/house/living-room.jpg",
  kitchen: "/house/kitchen.jpg",
  piano: "/house/piano.jpg",
  bedroomOne: "/house/bedroom-1.jpg",
  bedroomTwo: "/house/bedroom-2.jpg",
  bedroomThree: "/house/bedroom-3.jpg",
  poolSpa: "/house/pool-night.jpg",
  exterior: "/house/outdoor-house.jpg",
  patio: "/house/outdoor-table.jpg",
  poolHouse: "/house/pool-daytime.jpg",
  cozyLiving: "/house/outdoor-seating.jpg",
  guestBath: "/house/guest-bath.jpg",
  laundry: "/house/laundry.jpg",
  petFriendly: "/house/pet-friendly.jpg",
};

export const HERO = {
  eyebrow: "Let us host your next",
  title: "Getaway or Event",
  description:
    "Indulge in our 3BD/2BA haven complete with a pool, spa, and tanning ledge. Enjoy outdoor activities, relax under 2 pergolas, or simply bask in tranquility. With full furnishing, WiFi, Netflix, and spotless surroundings, it's an oasis of comfort. The Jackson House - where your little slice of paradise awaits!",
  cta: "Book Now",
};

export const INTRO = {
  small: "ESCAPE TO",
  big: "THE JACKSON HOUSE",
  body:
    "Looking for the perfect venue for your next event? Look no further than the Jackson House! Not only is it a cozy and charming Airbnb, but it's also available for events. Whether you're planning a family gathering, a workshop, or a small celebration \u2013 We've got you covered!",
};

export const FEATURES = [
  {
    imgKey: "cardAccommodation",
    title: "Accommodation",
    text: "An amazing private outdoor pool and spa for those relaxing days and evening you've been dreaming of.",
  },
  {
    imgKey: "cardIndoor",
    title: "Indoor Fun",
    text: "Full Size Poker table for adults and arcade machine for the kids make the Jackson House the perfect getaway.",
  },
  {
    imgKey: "cardRGV",
    title: "Escape within the RGV",
    text: "Relax in style, comfort and privacy featuring amazing patio dining, grill and even mini golf!",
  },
];

export const ROOMS = [
  {
    id: "bedroom-one",
    title: "Bedroom One",
    subtitle: "One Queen Bed & One Toddler Bed",
    text: "The master bedroom features a cozy queen-sized bed for restful nights and a charming toddler bed tucked in the corner, creating a perfect space for family comfort. Soft lighting and gentle decor make this room a serene retreat for both adults and little ones.",
    imgKey: "bedroomOne",
    reverse: false,
  },
  {
    id: "bedroom-two",
    title: "Bedroom Two",
    subtitle: "One King Size Bed",
    text: "Bedroom Two boasts a spacious king bed, elegantly dressed in soft linens and surrounded by tranquil colors that create a peaceful haven for relaxation. The room's thoughtfully designed layout ensures both comfort and style, perfect for unwinding after a long day.",
    imgKey: "bedroomTwo",
    reverse: true,
  },
  {
    id: "bedroom-three",
    title: "Bedroom Three",
    subtitle: "Two Twin Sized Beds",
    text: "Bedroom Three offers ample space with two twin-sized beds, making it ideal for siblings or guests to enjoy a comfortable stay. The room's generous layout and bright, airy atmosphere enhance its versatility and charm.",
    imgKey: "bedroomThree",
    reverse: false,
  },
  {
    id: "pool-spa",
    title: "Private Outdoor Pool & Spa",
    subtitle: "Relax Outdoor in Style and Comfort",
    text: "The private outdoor pool and spa provide a luxurious retreat, with sparkling waters inviting you to unwind and soak up the sun. Surrounded by elegant loungers and lush landscaping, this serene oasis is perfect for relaxation and enjoying a refreshing dip in privacy.",
    imgKey: "poolSpa",
    reverse: true,
  },
];

export const EXTRAS = [
  {
    imgKey: "workspace",
    title: "Work Space",
    text: "Our home features a well-appointed workspace designed for productivity and comfort, complete with a spacious desk, ergonomic chair, and high-speed internet. Whether you're working remotely or catching up on personal projects, this dedicated area ensures you have everything you need to stay focused and efficient.",
  },
  {
    imgKey: "livingRoom",
    title: "Living Room",
    text: "The modern living room offers a chic and inviting space to relax, with sleek furnishings, a plush sofa, and a stylish coffee table. Its open design and contemporary decor create a perfect environment for unwinding, entertaining, or simply enjoying some downtime.",
  },
  {
    imgKey: "kitchen",
    title: "Full Kitchen",
    text: "Our full kitchen is a culinary haven, equipped with state-of-the-art appliances, ample counter space, and all the essentials needed to prepare delicious meals. Whether you're cooking a family dinner or whipping up a quick snack, this modern kitchen makes cooking a pleasure.",
  },
  {
    imgKey: "piano",
    title: "Music Anyone?",
    text: "Our home features a beautiful piano, adding a touch of elegance and charm to the living space. Whether you're a seasoned pianist or a casual player, this inviting instrument provides a perfect opportunity to enjoy music and enhance your stay.",
  },
];

export const CONTACT = {
  address: "The Jackson House \u2013 McAllen, TX",
  checkIn: "after 3:00 pm",
  checkOut: "before 11:00 am",
  notes: [
    "Late check-out available, ask for rate.",
    "There is free private parking available for guests.",
  ],
  whatsapp: "https://wa.me/qr/K6E2EMQOVI5GO1",
  socials: {
    instagram: "https://www.instagram.com/thejacksonhousergv/",
    tiktok: "https://www.tiktok.com/@thejacksonhousergv956",
  },
  maps: {
    apple: "https://maps.apple.com/?q=The%20Jackson%20House%20RGV%2C%20McAllen%2C%20TX",
    google: "https://share.google/5A6aN1SNH9oDWGCDj",
  },
};

export const GALLERY = [
  { key: "hero", label: "The Jackson House" },
  { key: "cardAccommodation", label: "Pool at Dusk" },
  { key: "cardIndoor", label: "Indoor Fun" },
  { key: "cardRGV", label: "Backyard Oasis" },
  { key: "poolSpa", label: "Private Pool & Spa" },
  { key: "patio", label: "Patio Dining" },
  { key: "exterior", label: "Home Exterior" },
  { key: "bedroomOne", label: "Bedroom One" },
  { key: "bedroomTwo", label: "Bedroom Two" },
  { key: "bedroomThree", label: "Bedroom Three" },
  { key: "livingRoom", label: "Living Room" },
  { key: "kitchen", label: "Full Kitchen" },
  { key: "workspace", label: "Work Space" },
  { key: "piano", label: "Music Room" },
  { key: "cozyLiving", label: "Cozy Corner" },
  { key: "poolHouse", label: "Poolside Living" },
  { key: "petFriendly", label: "Pet Friendly" },
  { key: "guestBath", label: "Guest Bath" },
  { key: "laundry", label: "Laundry Room" },
];

export const DEFAULT_EVENT_GALLERY = Array.from({ length: 15 }, (_, i) => `/events/event-${i + 1}.jpg`);

export const TESTIMONIALS = [
  {
    name: "Noemi",
    location: "El Paso, Texas",
    rating: 5,
    text: "Great place to stay! The space was clean, comfortable, and exactly as described. The hosts were friendly and responsive throughout, and the pool was amazingly relaxing. Had everything we needed and felt right at home. Would definitely stay again!",
  },
  {
    name: "Leslie",
    location: "Group trip",
    rating: 5,
    text: "The house has every amenity possible — pool towels, a Bluetooth speaker, indoor and outdoor games. Plenty of space inside and out. The decor and vibes create the perfect vacation getaway. I had a very memorable birthday.",
  },
  {
    name: "Luis",
    location: "McAllen, Texas",
    rating: 5,
    text: "Excellent weekend getaway, had a wonderful time with family. Tatiana was quick to respond to any questions. The place was spotless and matched the listing. Will definitely be booking again.",
  },
  {
    name: "Carolina",
    location: "San Francisco, California",
    rating: 5,
    text: "We loved our stay — our kids had a blast at the pool and the house had everything we needed: lots of board games, towels, and my son's favorite, the PAC-Man arcade. Definitely staying here next time we visit.",
  },
  {
    name: "Brenda",
    location: "San Angelo, Texas",
    rating: 5,
    text: "My family and I enjoyed our stay at the Jackson House. Such a beautiful home and amazing backyard. We loved the pool and fun play area for the kids. Communication with the host was helpful whenever we needed it.",
  },
  {
    name: "Michelle",
    location: "Harlingen, Texas",
    rating: 5,
    text: "Great location for a small family celebration. My daughter loved all the amenities available to our guests during her birthday party. A wonderful, welcoming space.",
  },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Booking", to: "/booking" },
  { label: "Events", to: "/events" },
  { label: "Gallery", to: "/gallery" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact Us", to: "/contact" },
];

export const STATS = [
  { value: 4.92, decimals: 2, suffix: "", label: "Guest Rating", prefix: "" },
  { value: 39, decimals: 0, suffix: "", label: "Airbnb Reviews", prefix: "" },
  { value: 3, decimals: 0, suffix: "BD", label: "Bedrooms", prefix: "" },
  { value: 8, decimals: 0, suffix: "", label: "Sleeps Up To", prefix: "" },
];

export const MARQUEE = [
  "Private Pool & Spa",
  "3BD / 2BA",
  "Netflix & WiFi",
  "Poker & Arcade",
  "Mini Golf",
  "Patio Dining",
  "2 Pergolas",
  "Tanning Ledge",
  "McAllen, TX",
];
